import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Heading3Svg = function Heading3Svg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("g", {
      fill: "#000",
      clipPath: "url(#heading3__a)",
      children: /*#__PURE__*/_jsx("path", {
        d: "M1.532 10.364V0H0v24h1.532V12h10.723v12h1.532V0h-1.532v10.364zM18.83 12.273c-1.164 0-2.107 1.007-2.107 2.25v1.024h1.532v-1.024c0-.34.258-.614.575-.614h2.68c.318 0 .575.275.575.614v1.636c0 .34-.257.614-.574.614h-3.13v1.636h3.513c.317 0 .574.275.574.613v2.455c0 .34-.257.614-.574.614h-3.447c-.317 0-.575-.275-.575-.614v-1.023H16.34v1.023c0 1.243.944 2.25 2.107 2.25h3.447c1.163 0 2.106-1.007 2.106-2.25v-2.455c0-.665-.27-1.263-.7-1.675.2-.344.317-.752.317-1.188v-1.636c0-1.243-.943-2.25-2.106-2.25z"
      })
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "heading3__a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h24v24H0z"
        })
      })
    })]
  });
};
export var Heading3 = function Heading3(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: Heading3Svg
  }));
};